<template>
  <card>
    <h3 slot="header" class="mb-0">Milestone Template for ({{ model.milestone_template_name }}) </h3>
    <div class="text-right" v-if="button_access.edit_template_button == 'YES'">
      <router-link :to="'/templates/milestoneTemplateEdit/' + model.milestone_template_id">
        <base-button v-if="myUserID.role_id == 3" size="sm" type="primary">Edit</base-button>
      </router-link>
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="12">
          <base-input label="Template Name"
                      name="Template Name"
                      placeholder="Template Name"
                      v-model="model.milestone_template_name" disabled>
          </base-input>
        </b-col>
      </div>
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      var milestone_template_access = JSON.parse(window.localStorage.getItem('milestone_template_access'))
      this.button_access.edit_template_button = milestone_template_access.access_edit

      const LoginUser = JSON.parse(window.localStorage.getItem('loginUser'))
      this.myUserID = LoginUser

      this.model.milestone_template_id = this.$route.params.id

      axios.get(apiDomain + 'template/milestone_template/'+this.model.milestone_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.model.milestone_template_id = response.data.data[0].milestone_template_id
          this.model.milestone_template_name = response.data.data[0].milestone_template_name
        }
      })
      .catch ( error => {
        console.log(error.response.status)
        this.errorFunction(error, 'Milestone Template Information')
      } );
    },
    data() {
      return {
        model: {
          milestone_template_name: null,
          milestone_template_id: null,
        },
        button_access:{
          edit_template_button: null,
        },
        myUserID: null,
      }
    },
    methods: {

    }
  }
</script>
<style>
</style>
